export function maskPhone(phone = '') {
    const masksObj = {
        8: '####-####',
        9: '#####-####',
        10: '(##) ####-####',
        11: '(##) #####-####',
        12: '+## (##) ####-####',
        13: '+## (##) #####-####',
        14: '+## (##) ####-####',
    }

    const phoneClean = phone.replace(/\D/g, '')

    const mask = masksObj[phoneClean.length]

    if (!mask) return phone

    let maskedPhone = ''

    let i = 0

    mask.split('').forEach((char) => {
        if (char === '#') {
            maskedPhone += phoneClean[i]
            i++
        } else {
            maskedPhone += char
        }
    })

    return maskedPhone
}
